export default __webpack_public_path__ + "8a153d11a352db4484d24830cfa61daf.woff2";